import { observable, action, computed  } from 'mobx'
import axios from '../services/axios'
import NotificationStore from './notification'


class WidgetStore {

  @observable data = {}
  @observable payload = {}
  @observable themeColorPickerToggle = false
  @observable fontColorPickerToggle = false

  @computed get payloadChanged() {
    const keys = [
      'material_id',
      'program_name',
      'launcher_content',
      'launcher_desktop_layout',
      'theme_color',
      'font_color',
      'position',
      'horizontal_margin',
      'vertical_margin',
    ] 
    let payloadStr = ''
    let dataStr = ''
    keys.map(item => {
      payloadStr += String(this.payload[item])
      dataStr += String(this.data[item])
      return 1
    })
    return payloadStr !== dataStr
  }

  @action setThemeColorPickerToggle = () => {
    this.themeColorPickerToggle = !this.themeColorPickerToggle
  }

  @action setFontColorPickerToggle = () => {
    this.fontColorPickerToggle = !this.fontColorPickerToggle
  }

  @action setData = data => {
    this.data = data
  }

  @action initPayload = () => {
    // copy
    this.payload = Object.assign({}, this.data)
  }

  @action fetchData = () => {
    axios.get('/widget').then(res => {
      if (res.data.success === 1) {
        this.setData(res.data.data)
        this.initPayload()
      }
    })
  }

  @action update = () => {
    axios.put('/widget', this.payload).then(res => {
      if (res.data.success === 1) {
        this.fetchData()
        NotificationStore.notify(
          'success',
          'info',
          'Widget settings updated.'
        )
      }
    })
  }

  @action payloadOnChange = (k, v) => {
    this.payload[k] = v
  }
}

export default new WidgetStore()